import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import { isMenzzoSavHost } from "@/core/helpers/hostname";

const menzzoRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "sav-landing",
    component: () => import("@/views/crafted/pages/sav/Index.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "sav-landing" },
  },
];

const meublePromoRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/order",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/order",
        name: "order",
        component: () => import("@/views/crafted/pages/order/Index.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/home",
        name: "sale-search",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/Home.vue"),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const isMenzzoSav = isMenzzoSavHost();
const routes = isMenzzoSav ? menzzoRoutes : meublePromoRoutes;

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  if (!isMenzzoSav) {
    store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
